var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconFilterEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.197,
    height: 11.142,
    viewBox: "0 0 11.197 11.142",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-0.001 -1.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50902",
    "data-name": "Path 50902",
    d: "M6.963,3.148,9.241,5.426,3.475,11.191,1.2,8.914ZM10.969,2.6,9.953,1.583a1.008,1.008,0,0,0-1.424,0l-.973.973L9.834,4.834,10.969,3.7A.777.777,0,0,0,10.969,2.6ZM.007,12.115a.259.259,0,0,0,.314.308l2.538-.615L.582,9.531Z",
    transform: "translate(0)",
    fill: "#afafaf"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconFilterEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_filter_edit.9332303ff8a8d4abdccc2c73b8474b95.svg";